<p-toast position="top-right"></p-toast>
<div class="stepper-container" style="height: 90vh; display: flex; flex-direction: column; overflow: hidden">
  <p-breadcrumb class="max-w-full" [model]="items" [home]="home"></p-breadcrumb>
  <h2 class="site-header">
    {{ isCategoryMode ? 'Create/Update Category' : 'Create/Update Site' }} -
    {{
    siteNameFromSession ||
    firstFormGroup.get("siteNameCtrl")?.value ||
    (isCategoryMode ? "categoryname" : "sitename")
    }}
  </h2>

  <!-- Configuration Status Indicator -->
  <!-- <div *ngIf="hasSavedConfiguration" class="config-status-indicator">
        <span class="material-icons config-status-icon">check_circle</span>
        <span class="config-status-text">Configuration Loaded - All saved settings are displayed</span>
    </div> -->

  <!-- Configuration Loading Indicator -->
  <div *ngIf="isLoadingConfiguration" class="config-loading-indicator">
    <mat-spinner diameter="20" style="margin-right: 8px"></mat-spinner>
    <span class="config-loading-text">Loading saved configuration...</span>
  </div>
  <mat-stepper [linear]="true" #stepper style="flex: 1; overflow: scroll; display: flex; flex-direction: column">
    <mat-step [stepControl]="firstFormGroup" style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
      <p-divider type="solid"></p-divider>
      <!-- Navigation buttons at top -->
      <div class="step-navigation-top"
        style="display: flex; justify-content: flex-end; padding: 8px 16px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px;">
        <button mat-button matStepperNext (click)="onFirstStepNext(stepper)">
          Next
          <mat-icon style="vertical-align: middle; margin-left: 4px">arrow_forward</mat-icon>
        </button>
      </div>
      <form [formGroup]="firstFormGroup" style="flex: 1; overflow-y: auto; padding-right: 8px">
        <!-- Loading overlay -->
        <div *ngIf="isLoadingFormData" style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.8);
            z-index: 1000;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
          <div style="text-align: center">
            <mat-spinner diameter="40" style="margin: 0 auto 16px"></mat-spinner>
            <p style="color: #666; margin: 0">Loading site data...</p>
          </div>
        </div>

        <ng-template matStepLabel>
          <span class="step-label-large" [ngClass]="{
              'step-completed': isFirstStepCompleted,
              'step-error': isFirstStepError
            }">
            <span class="material-icons step-label-icon" [ngClass]="{
                'icon-completed': isFirstStepCompleted,
                'icon-error': isFirstStepError
              }">
              {{
              isFirstStepCompleted ? "done" : isFirstStepError ? "error" : ""
              }}
            </span>
            {{ isCategoryMode && isNew ? 'New Category Details' : (isCategoryMode ? 'Category Details' : 'Basic
            Details') }}
          </span>
        </ng-template>
        <div style="
            position: absolute;
            top: 60px;
            right: 32px;
            z-index: 10;
            display: flex;
            align-items: center;
            gap: 8px;
          ">
          <span>Configuration Tutorial</span>
          <img src="assets/images/icons8-info-50.png" alt="Help" style="width: 24px; height: 24px; cursor: pointer"
            (click)="openYoutubeHelp(youtubeStepVideoIds[0])" />
        </div>
        <!-- Split Screen Layout: 50% Form + 50% Logo -->
        <div class="split-screen-container" style="display: flex; height: 100%; min-height: 500px">
          <!-- Left 50% - Form Content -->
          <div class="form-section" style="
              flex: 1;
              padding: 40px 60px;
              background: #f8f9fa;
              display: flex;
              flex-direction: column;
              justify-content: center;
              border-radius: 20px 0px 0px 20px;
            ">
            <div class="form-content" style="max-width: 800px; margin: 0 auto; width: 100%">
              <!-- Form Header -->

              <!-- Form Fields Layout -->
              <!-- Site Name and Site Address Row -->
              <div class="static-label-row" style="display: flex; gap: 40px; margin-bottom: 24px">
                <div class="static-label-group" style="flex: 1">
                  <label for="siteName" class="static-label" style="
                      font-weight: bold;
                      background-color: #f8f9fa;
                      border-radius: 4px;
                    ">{{ isCategoryMode ? 'Category Name' : 'Site Name' }}</label>
                  <input id="siteName" type="text"
                    [placeholder]="isCategoryMode ? 'Enter category name' : 'Enter site name'"
                    formControlName="siteNameCtrl" required class="static-input" [ngClass]="{
                      'input-error':
                        firstFormGroup.get('siteNameCtrl')?.invalid &&
                        firstFormGroup.get('siteNameCtrl')?.touched
                    }" />
                  <div
                    *ngIf="firstFormGroup.get('siteNameCtrl')?.invalid && firstFormGroup.get('siteNameCtrl')?.touched"
                    style="color: #f44336; font-size: 12px; margin-top: 4px;">
                    {{ isCategoryMode ? 'Category Name is required' : 'Site Name is required' }}
                  </div>
                </div>
                <div class="static-label-group" style="flex: 1" *ngIf="!isCategoryMode">
                  <label for="siteAddress" class="static-label" style="
                      font-weight: bold;
                      background-color: #f8f9fa;
                      border-radius: 4px;
                    ">{{ isCategoryMode ? 'Category Address' : 'Site Address' }}</label>
                  <input id="siteAddress" type="text" placeholder="Enter site address" formControlName="siteAddressCtrl"
                    required class="static-input" [ngClass]="{
                      'input-error':
                        firstFormGroup.get('siteAddressCtrl')?.invalid &&
                        firstFormGroup.get('siteAddressCtrl')?.touched
                    }" />
                  <div
                    *ngIf="firstFormGroup.get('siteAddressCtrl')?.invalid && firstFormGroup.get('siteAddressCtrl')?.touched"
                    style="color: #f44336; font-size: 12px; margin-top: 4px;">
                    Site Address is required
                  </div>
                </div>
              </div>

              <!-- Contact Number and Plant View Row -->
              <div class="static-label-row" style="display: flex; gap: 40px; margin-bottom: 24px"
                *ngIf="!isCategoryMode">
                <div class="static-label-group" style="flex: 1">
                  <label for="contactNumber" class="static-label" style="
                      font-weight: bold;
                      background-color: #f8f9fa;
                      border-radius: 4px;
                    ">Contact Number</label>
                  <input id="contactNumber" type="text" placeholder="Enter contact number"
                    formControlName="contactNumberCtrl" required maxlength="16" class="static-input"
                    (keypress)="onContactNumberKeyPress($event)" (paste)="onContactNumberPaste($event)" [ngClass]="{
                      'input-error':
                        firstFormGroup.get('contactNumberCtrl')?.invalid &&
                        firstFormGroup.get('contactNumberCtrl')?.touched
                    }" />
                  <div
                    *ngIf="firstFormGroup.get('contactNumberCtrl')?.invalid && firstFormGroup.get('contactNumberCtrl')?.touched"
                    style="color: #f44336; font-size: 12px; margin-top: 4px;">
                    <span *ngIf="firstFormGroup.get('contactNumberCtrl')?.errors?.['required']">Contact Number is
                      required</span>
                    <span *ngIf="firstFormGroup.get('contactNumberCtrl')?.errors?.['pattern']">Only numbers allowed (+
                      sign optional at start, max 15 digits)</span>
                    <span *ngIf="firstFormGroup.get('contactNumberCtrl')?.errors?.['maxlength']">Maximum 15 digits
                      allowed</span>
                  </div>
                </div>
                <div class="static-label-group" style="flex: 1">
                  <label for="plantView" class="static-label" style="
                      font-weight: bold;
                      background-color: #f8f9fa;
                      border-radius: 4px;
                    ">{{ isCategoryMode ? 'Category View' : 'Plant View' }}</label>
                  <select id="plantView" formControlName="plantViewCtrl" required class="static-input" [ngClass]="{
                      'input-error':
                        firstFormGroup.get('plantViewCtrl')?.invalid &&
                        firstFormGroup.get('plantViewCtrl')?.touched
                    }">
                    <option value="" disabled selected>
                      Select plant view
                    </option>
                    <option value="default">Default</option>
                    <option value="groupsAndSubgroups">
                      Groups and Subgroups
                    </option>
                  </select>
                  <div
                    *ngIf="firstFormGroup.get('plantViewCtrl')?.invalid && firstFormGroup.get('plantViewCtrl')?.touched"
                    style="color: #f44336; font-size: 12px; margin-top: 4px;">
                    Plant View is required
                  </div>
                </div>
              </div>

              <!-- Site Description, Currency and Global Data Cleansing Row -->
              <div class="static-label-row"
                style="display: flex; gap: 40px; margin-bottom: 32px; align-items: stretch;">
                <!-- Site Description -->
                <div class="static-label-group" style="flex: 1; display: flex; flex-direction: column;">
                  <label for="siteDescription" class="static-label" style="
                      font-weight: bold;
                      background-color: #f8f9fa;
                      border-radius: 4px;
                    ">{{ isCategoryMode ? 'Category Description' : 'Site Description' }}</label>
                  <div style="position: relative; flex: 1; display: flex; flex-direction: column;">
                    <textarea id="siteDescription"
                      [placeholder]="isCategoryMode ? 'Enter category description' : 'Enter site description'"
                      formControlName="siteDescriptionCtrl" required class="static-input"
                      style="flex: 1; min-height: 180px; white-space: pre-wrap; word-wrap: break-word;" [ngClass]="{
                        'input-error':
                          firstFormGroup.get('siteDescriptionCtrl')?.invalid &&
                          firstFormGroup.get('siteDescriptionCtrl')?.touched
                      }"></textarea>
                    <button type="button" class="expand-description-btn" (click)="openDescriptionModal()"
                      title="Expand description">
                      <span class="material-icons">open_in_full</span>
                    </button>
                  </div>
                  <div
                    *ngIf="firstFormGroup.get('siteDescriptionCtrl')?.invalid && firstFormGroup.get('siteDescriptionCtrl')?.touched"
                    style="color: #f44336; font-size: 12px; margin-top: 4px;">
                    {{ isCategoryMode ? 'Category Description is required' : 'Site Description is required' }}
                  </div>
                </div>
                <!-- Currency and Global Data Cleansing Column -->
                <div style="flex: 0 0 300px; display: flex; flex-direction: column; gap: 16px;" *ngIf="!isCategoryMode">
                  <!-- Currency -->
                  <div class="static-label-group" style="flex: 1; margin-bottom: 0;">
                    <label for="currency" class="static-label" style="
                        font-weight: bold;
                        background-color: #f8f9fa;
                        border-radius: 4px;
                      ">Currency</label>
                    <p-dropdown id="currency" formControlName="currencyCtrl" [options]="currencies" optionLabel="code"
                      optionValue="code" placeholder="Select currency" [filter]="true" filterBy="code,name,country"
                      [showClear]="false" [style]="{'width': '100%'}" [panelStyle]="{'max-width': '300px'}"
                      styleClass="currency-dropdown" [ngClass]="{
                        'ng-invalid ng-dirty':
                          firstFormGroup.get('currencyCtrl')?.invalid &&
                          firstFormGroup.get('currencyCtrl')?.touched
                      }">
                      <ng-template pTemplate="selectedItem" let-currency>
                        <span *ngIf="currency">{{ currency.code }} ({{ currency.symbol }})</span>
                      </ng-template>
                      <ng-template pTemplate="item" let-currency>
                        <span>{{ currency.code }} ({{ currency.symbol }}) - {{ currency.country }}</span>
                      </ng-template>
                    </p-dropdown>
                    <div
                      *ngIf="firstFormGroup.get('currencyCtrl')?.invalid && firstFormGroup.get('currencyCtrl')?.touched"
                      style="color: #f44336; font-size: 12px; margin-top: 4px;">
                      Currency is required
                    </div>
                  </div>
                  <!-- Global Data Cleansing -->
                  <div class="static-label-group" style="flex: 1; margin-bottom: 0;">
                    <label for="globalDataCleansing" class="static-label" style="
                        font-weight: bold;
                        background-color: #f8f9fa;
                        border-radius: 4px;
                      ">Global Data Cleansing</label>
                    <select id="globalDataCleansing" formControlName="globalDataCleansingCtrl" required
                      class="static-input" [ngClass]="{
                        'input-error':
                          firstFormGroup.get('globalDataCleansingCtrl')
                            ?.invalid &&
                          firstFormGroup.get('globalDataCleansingCtrl')?.touched
                      }">
                      <option value="" disabled [selected]="
                          !firstFormGroup.get('globalDataCleansingCtrl')?.value
                        ">
                        Select option
                      </option>
                      <option value="dataWithNoValue">Data With No Value</option>
                      <option value="dataWithNoDate">Data With No Date</option>
                      <option value="Factory">Default</option>
                    </select>
                    <div
                      *ngIf="firstFormGroup.get('globalDataCleansingCtrl')?.invalid && firstFormGroup.get('globalDataCleansingCtrl')?.touched"
                      style="color: #f44336; font-size: 12px; margin-top: 4px;">
                      Global Data Cleansing is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right 50% - Logo Section -->
          <div class="logo-section" style="
              flex: 1;
              background: #f8f9fa;
              position: relative;
              border-radius: 0px 20px 20px 0px;
            ">
            <div class="logo-container" style="position: absolute; bottom: 0; right: 0">
              <img src="./assets/images/PURE-BI---2.png" alt="Company Logo" style="
                  max-width: 400px;
                  max-height: 500px;
                  width: auto;
                  height: auto;
                  display: block;
                  opacity: 0.3;
                " />
              <!-- <div style="margin-top: 20px; color: white; font-size: 18px; font-weight: 500;">
                                Pure BI Platform
                            </div>
                            <div style="margin-top: 8px; color: #ccc; font-size: 14px;">
                                Site Configuration
                            </div> -->
            </div>
          </div>
        </div>
        <div class="static-label-row" *ngIf="hasRole1() && !isCategoryMode">
          <div class="static-label-group" style="flex: 1 1 30%; max-width: 250px">
            <label for="assistantId" class="static-label">Assistant Id</label>
            <input id="assistantId" type="text" placeholder="enter assistant id" formControlName="assistantIdCtrl"
              required class="static-input" [ngClass]="{
                'input-error':
                  firstFormGroup.get('assistantIdCtrl')?.invalid &&
                  firstFormGroup.get('assistantIdCtrl')?.touched
              }" />
          </div>
          <div class="static-label-group" style="flex: 2 1 60%; max-width: 250px">
            <label for="apiKey" class="static-label">Api Key</label>
            <input id="apiKey" type="text" placeholder="enter api key" formControlName="apiKeyCtrl" required
              class="static-input" [ngClass]="{
                'input-error':
                  firstFormGroup.get('apiKeyCtrl')?.invalid &&
                  firstFormGroup.get('apiKeyCtrl')?.touched
              }" />
          </div>
          <div class="static-label-group" style="flex: 1 1 30%; max-width: 250px">
            <label for="alertType" class="static-label">Alert Type</label>
            <select id="alertType" formControlName="alertTypeCtrl" required class="static-input" [ngClass]="{
                'input-error':
                  firstFormGroup.get('alertTypeCtrl')?.invalid &&
                  firstFormGroup.get('alertTypeCtrl')?.touched
              }">
              <option value="" disabled selected>select alert type</option>
              <option value="default">Default</option>
              <option value="groupsAndSubgroups">Advance Alert</option>
            </select>
          </div>
        </div>
        <div class="static-label-row" *ngIf="hasRole6() && !isCategoryMode">
          <div class="static-label-group" style="flex: 1 1 30%; max-width: 250px">
            <label for="latitude" class="static-label">Latitude</label>
            <input id="latitude" type="text" placeholder="latitude" formControlName="latitudeCtrl" required
              class="static-input" [ngClass]="{
                'input-error':
                  firstFormGroup.get('latitudeCtrl')?.invalid &&
                  firstFormGroup.get('latitudeCtrl')?.touched
              }" />
          </div>
          <div class="static-label-group" style="flex: 2 1 60%; max-width: 250px">
            <label for="longitude" class="static-label">Longitude</label>
            <input id="longitude" type="text" placeholder="longitude" formControlName="longitudeCtrl" required
              class="static-input" [ngClass]="{
                'input-error':
                  firstFormGroup.get('longitudeCtrl')?.invalid &&
                  firstFormGroup.get('longitudeCtrl')?.touched
              }" />
          </div>
          <div class="static-label-group" style="flex: 2 1 60%; max-width: 250px">
            <label for="category" class="static-label">Category</label>
            <input id="category" type="text" placeholder="category" formControlName="categoryCtrl" required
              class="static-input" [ngClass]="{
                'input-error':
                  firstFormGroup.get('categoryCtrl')?.invalid &&
                  firstFormGroup.get('categoryCtrl')?.touched
              }" />
          </div>
        </div>
        <div *ngIf="lastSavedTimestamp" style="
            margin-top: 8px;
            font-size: 12px;
            color: #666;
            font-style: italic;
          ">
          Last saved: {{ lastSavedTimestamp | date : "medium" }}
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" label=""
      style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
      <p-divider type="solid"></p-divider>
      <!-- Navigation buttons at top -->
      <div class="step-navigation-top"
        style="display: flex; justify-content: space-between; padding: 8px 16px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px;"
        *ngIf="(isCategoryMode) || (secondFormGroup.get('channels')?.value && secondFormGroup.get('positions')?.value)">
        <button mat-button (click)="onModuleConfigStepBack(stepper)">
          <mat-icon style="vertical-align: middle; margin-right: 4px">arrow_back</mat-icon>Back
        </button>
        <button mat-button (click)="onSecondStepNext(stepper, $event)"
          *ngIf="secondFormGroup.get('channels')?.value && secondFormGroup.get('positions')?.value">
          Next
          <mat-icon style="vertical-align: middle; margin-left: 4px">arrow_forward</mat-icon>
        </button>
      </div>
      <form [formGroup]="secondFormGroup" style="flex: 1; overflow-y: auto; padding-right: 8px; margin-bottom: 0">
        <ng-template matStepLabel>
          <span class="step-label-large" [ngClass]="{
              'step-completed': isSecondStepCompleted,
              'step-error': isSecondStepError
            }">
            <span class="material-icons step-label-icon" [ngClass]="{
                'icon-completed': isSecondStepCompleted,
                'icon-error': isSecondStepError
              }">
              {{
              isSecondStepCompleted
              ? "done"
              : isSecondStepError
              ? "error"
              : ""
              }}
            </span>
            {{ isNew && isCategoryMode ? 'Add & Configure Module' : 'Edit & Configure Module' }}
          </span>
        </ng-template>
        <div style="
            position: absolute;
            top: 60px;
            right: 32px;
            z-index: 10;
            display: flex;
            align-items: center;
            gap: 8px;
          ">
          <span>Configuration Tutorial</span>
          <img src="assets/images/icons8-info-50.png" alt="Help" style="width: 24px; height: 24px; cursor: pointer"
            (click)="openYoutubeHelp(youtubeStepVideoIds[0])" />
        </div>
        <div class="config-row" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          ">
          <div style="display: flex; align-items: center; gap: 5px">
            <span class="config-title">ADD & CONFIGURE MODULES:</span>
            <div class="config-field">
              <label style="display: flex; align-items: center">
                <input type="number" [min]="maxChannelValue > 0 ? maxChannelValue : 1" formControlName="channels"
                  placeholder="0" class="config-input"
                  [class.error]="secondFormGroup.get('channels')?.hasError('minChannelPosition')" required />
                <span style="margin-left: 2px">Channels</span>
              </label>
              <div *ngIf="secondFormGroup.get('channels')?.hasError('minChannelPosition')" class="validation-error"
                style="color: red; font-size: 12px; margin-left: 5px;">
                Minimum: {{ maxChannelValue }}
              </div>
            </div>
            <div class="config-field" style="margin-left: 10px">
              <label style="display: flex; align-items: center">
                <input type="number" [min]="maxPositionValue > 0 ? maxPositionValue : 1" formControlName="positions"
                  placeholder="0" class="config-input"
                  [class.error]="secondFormGroup.get('positions')?.hasError('minChannelPosition')" required />
                <span style="margin-left: 2px">Positions</span>
              </label>
              <div *ngIf="secondFormGroup.get('positions')?.hasError('minChannelPosition')" class="validation-error"
                style="color: red; font-size: 12px; margin-left: 5px;">
                Minimum: {{ maxPositionValue }}
              </div>
            </div>
          </div>
          <div style="display: flex; gap: 0">
            <button type="button" class="config-system-btn"
              (click)="handleModuleConfigClick('Complete System', $event)">
              <span class="material-icons" style="vertical-align: middle; margin-right: 8px">settings</span>
              Complete System
            </button>
            <button type="button" class="config-system-btn"
              (click)="handleModuleConfigClick('Corporate Module', $event)">
              <span class="material-icons" style="vertical-align: middle; margin-right: 8px">settings</span>
              Corporate Module
            </button>
            <button type="button" class="config-system-btn" (click)="handleModuleConfigClick('Lab Module', $event)">
              <span class="material-icons" style="vertical-align: middle; margin-right: 8px">settings</span>
              Lab Module
            </button>
          </div>
        </div>
        <!-- Axis labels and grid wrapper -->
        <div class="axis-grid-wrapper" *ngIf="
            secondFormGroup.get('channels')?.value &&
            secondFormGroup.get('positions')?.value
          ">
          <!-- X Axis (Positions) label and arrow -->
          <div class="axis-x-label">
            <span>Positions</span>
            <span class="material-icons axis-arrow">east</span>
          </div>
          <div style="display: flex; flex-direction: row">
            <!-- Y Axis (Channels) label and arrow -->
            <div class="axis-y-label">
              <span class="axis-y-text">Channels</span>
              <span class="material-icons axis-arrow">south</span>
            </div>
            <div class="grid-main-container">
              <!-- Column (Position) Labels -->
              <!-- <div style="display: flex; margin-left: 0; margin-bottom: 5px;">
                                <div style="width: 48px;"></div>
                                <ng-container
                                    *ngFor="let pos of [].constructor(secondFormGroup.get('positions')?.value); let col = index">
                                    <div style="width: 200px; text-align: center; font-weight: 600; color: #1976d2;">
                                        {{ getColumnLabel(col) }}
                                    </div>
                                </ng-container>
                            </div> -->
              <div class="grid-row-container">
                <!-- Row (Channel) Labels -->
                <div class="grid-row-labels">
                  <div class="grid-scroll-sync" #rowLabels>
                    <!-- Space for column headers - this should match the column header height -->
                    <div style="height: 52px"></div>
                    <ng-container *ngFor="
                        let ch of [].constructor(
                          secondFormGroup.get('channels')?.value
                        );
                        let row = index
                      ">
                      <div style="
                          height: 120px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-weight: 600;
                          color: #1976d2;
                          min-width: 40px;
                        ">
                        {{ getRowLabel(row) }}
                      </div>
                    </ng-container>
                    <!-- Add bottom padding to match grid container -->
                    <div style="height: 10px"></div>
                  </div>
                </div>
                <!-- Dotted grid container -->
                <div class="dotted-grid-scroll-x grid-scroll-sync" #gridScroll (scroll)="onGridScroll($event)"
                  [ngClass]="{
                    'enable-scroll-x':
                      secondFormGroup.get('positions')?.value > 6
                  }">
                  <!-- Column (Position) Labels -->
                  <div style="
                      display: flex;
                      margin-left: 0;
                      margin-bottom: 5px;
                      margin-top: 20px;
                    " [style.width.px]="
                      48 + secondFormGroup.get('positions')?.value * 200
                    ">
                    <ng-container *ngFor="
                        let pos of [].constructor(
                          secondFormGroup.get('positions')?.value
                        );
                        let col = index
                      ">
                      <div style="
                          width: 200px;
                          text-align: center;
                          font-weight: 600;
                          color: #1976d2;
                        ">
                        {{ getColumnLabel(col) }}
                      </div>
                    </ng-container>
                  </div>
                  <div class="dotted-grid-container" style="margin-left: 10px">
                    <div class="dotted-grid" [style.minWidth.px]="
                        secondFormGroup.get('positions')?.value * 200
                      " [style.height.px]="
                        secondFormGroup.get('channels')?.value * 120
                      " [style.position]="'relative'">
                      <!-- Vertical lines -->
                      <ng-container *ngFor="
                          let pos of [].constructor(
                            secondFormGroup.get('positions')?.value - 1
                          );
                          let i = index
                        ">
                        <div class="v-line" [style.left.%]="
                            ((i + 1) * 100) /
                            secondFormGroup.get('positions')?.value
                          "></div>
                      </ng-container>
                      <!-- Horizontal lines -->
                      <ng-container *ngFor="
                          let ch of [].constructor(
                            secondFormGroup.get('channels')?.value - 1
                          );
                          let j = index
                        ">
                        <div class="h-line" [style.top.%]="
                            ((j + 1) * 100) /
                            secondFormGroup.get('channels')?.value
                          "></div>
                      </ng-container>
                      <!-- Droppable cells -->
                      <ng-container *ngFor="
                          let ch of [].constructor(
                            secondFormGroup.get('channels')?.value
                          );
                          let row = index
                        ">
                        <ng-container *ngFor="
                            let pos of [].constructor(
                              secondFormGroup.get('positions')?.value
                            );
                            let col = index
                          ">
                          <div class="droppable-cell" [style.width.px]="200" [style.height.px]="120"
                            [style.position]="'absolute'" [style.left.px]="col * 200" [style.top.px]="row * 120"
                            (dragover)="onGridDragOver($event, row, col)" (dragleave)="onGridDragLeave($event)"
                            (drop)="onGridDrop($event, row, col)">
                            <ng-container *ngIf="
                                gridModules[row] && gridModules[row][col];
                                else emptyCell
                              ">
                              <div class="module-container"
                                [ngClass]="{'validation-error': hasModuleValidationError(row, col)}">
                                <button class="module-delete-btn" (click)="
                                    deleteModuleFromGrid(row, col, $event)
                                  " title="Delete module">
                                  <span class="material-icons">delete</span>
                                </button>
                                <div class="module-header">
                                  <span class="material-icons module-icon">inventory</span>
                                  <span class="module-title">{{
                                    getModuleDisplayName(gridModules[row][col])
                                    }}</span>
                                </div>
                                <button class="module-config-btn" (click)="
                                    openModuleConfigDialog(
                                      gridModules[row][col],
                                      $event,
                                      false,
                                      getRowLabel(row) + getColumnLabel(col)
                                    )
                                  ">
                                  <span class="material-icons">settings</span>
                                  Configure
                                </button>
                              </div>
                            </ng-container>
                            <ng-template #emptyCell>
                              <span class="grid-label">{{ getRowLabel(row)
                                }}{{ getColumnLabel(col) }}</span>
                            </ng-template>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fab-draggable" *ngIf="
            secondFormGroup.get('channels')?.value &&
            secondFormGroup.get('positions')?.value
          " [ngStyle]="fabStyle" (mousedown)="startDrag($event)" (touchstart)="startDrag($event)">
          <button type="button" class="fab-btn" [draggable]="!showPopover"
            (dragstart)="onModuleDragStart($event, 'Main Module')" (mouseup)="onFabMouseUp($event)"
            (touchend)="onFabMouseUp($event)" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
            <span class="fab-btn-text">Modules</span>
            <span class="pi pi-arrow-up-right fab-btn-icon"></span>
          </button>
          <div class="fab-popover" *ngIf="showPopover" [ngClass]="popoverPosition">
            <div class="popover-row" style="align-items: center">
              <span class="popover-text">Modules</span>
              <span class="pi pi-search fab-btn-icon" style="cursor: pointer; margin-left: 6px"
                *ngIf="!showModuleSearch" (click)="showModuleSearch = true"></span>
              <span class="pi pi-arrow-down-left fab-btn-icon" style="cursor: pointer; margin-left: 0"
                (click)="showPopover = false"></span>
            </div>
            <p class="fab-instruction-drag">
              Drag and drop modules to into the grid.
            </p>
            <input *ngIf="showModuleSearch" type="text" [(ngModel)]="moduleSearchText" placeholder="Search modules..."
              [ngModelOptions]="{ standalone: true }" style="
                margin-bottom: 10px;
                padding: 2px 8px;
                border-radius: 4px;
                border: 1px solid #b0bec5;
                width: 90%;
                display: block;
              " (blur)="showModuleSearch = !!moduleSearchText" />
            <span class="pi pi-times fab-btn-icon" style="
                cursor: pointer;
                margin-left: 6px;
                position: absolute;
                right: 18px;
                top: 62px;
              " *ngIf="showModuleSearch && moduleSearchText" (click)="clearModuleSearch()"></span>
            <div *ngFor="let mod of filteredModules" class="dummy-module decorated-module" draggable="true"
              (dragstart)="onModuleDragStart($event, mod.name)">
              <span class="module-label">{{ mod.name }}</span>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step *ngIf="showGroupModulesStep" label="Group Modules" [stepControl]="thirdFormGroup"
      style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
      <ng-container>
        <p-divider type="solid"></p-divider>
        <!-- Navigation buttons at top -->
        <div class="step-navigation-top"
          style="display: flex; justify-content: space-between; padding: 8px 16px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px;">
          <button mat-button (click)="onGroupModulesStepBack(stepper)">
            <mat-icon style="vertical-align: middle; margin-right: 4px">arrow_back</mat-icon>Back
          </button>
          <button mat-button (click)="onThirdStepNext(stepper)">
            Next
            <mat-icon style="vertical-align: middle; margin-left: 4px">arrow_forward</mat-icon>
          </button>
        </div>
        <form [formGroup]="thirdFormGroup" class="site-score-form"
          style="flex: 1; overflow-y: auto; padding-right: 8px">
          <ng-template matStepLabel>
            <span class="step-label-large" [ngClass]="{
                'step-completed': isThirdStepCompleted,
                'step-error': isThirdStepError
              }">
              <span class="material-icons step-label-icon" [ngClass]="{
                  'icon-completed': isThirdStepCompleted,
                  'icon-error': isThirdStepError
                }">
                {{
                isThirdStepCompleted
                ? "done"
                : isThirdStepError
                ? "error"
                : ""
                }}
              </span>
              Group Modules
            </span>
          </ng-template>
          <div style="
              position: absolute;
              top: 60px;
              right: 32px;
              z-index: 10;
              display: flex;
              align-items: center;
              gap: 8px;
            ">
            <span>Configuration Tutorial</span>
            <img src="assets/images/icons8-info-50.png" alt="Help" style="width: 24px; height: 24px; cursor: pointer"
              (click)="openYoutubeHelp(youtubeStepVideoIds[0])" />
          </div>
          <div style="
              display: flex;
              align-items: flex-start;
              gap: 24px;
              margin-bottom: 24px;
            ">
            <button mat-flat-button color="primary" type="button" class="dotted-border-btn" style="margin-bottom: 16px"
              (click)="onCreateNewGroup()">
              <span class="material-icons" style="vertical-align: middle; margin-right: 4px">add</span>
              Create New Group
            </button>
            <div class="group-summary-flex">
              <div *ngFor="let group of createdGroups; let gIdx = index" class="group-summary-container"
                [class.expanded]="group.isExpanded">
                <!-- Delete Group Icon -->
                <button mat-icon-button class="delete-group-icon" (click)="deleteGroup(gIdx)" matTooltip="Delete Group"
                  aria-label="Delete Group">
                  <span class="material-icons">delete</span>
                </button>

                <div class="group-summary-header">
                  {{ group.groupName }}
                </div>

                <div class="group-summary-content" [class.expanded]="group.isExpanded">
                  <div class="group-summary-section">
                    <!-- For groups with subGroups -->
                    <div *ngIf="group.subGroups">
                      <div *ngFor="let sub of group.subGroups; let subIdx = index" class="subgroup-card">
                        <!-- Delete Subgroup Icon -->
                        <button mat-icon-button class="delete-subgroup-icon" (click)="deleteSubgroup(gIdx, subIdx)"
                          matTooltip="Delete Subgroup" aria-label="Delete Subgroup">
                          <span class="material-icons">close</span>
                        </button>

                        <div class="group-module-title" style="font-weight: bold">
                          {{ sub.name }}
                        </div>
                        <div *ngFor="let mod of sub.modules" class="module-item">
                          <div class="module-info">
                            <span class="module-name">{{
                              getModuleNameByCode(mod.module_code)
                              }}</span>
                            <span class="module-code">({{ mod.module_code }})</span>
                          </div>
                          <div class="module-details">
                            Weight: {{ mod.weight }} | Position:
                            {{ mod.position }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- For groups without subGroups -->
                    <div *ngIf="group.modules">
                      <div *ngFor="let mod of group.modules" class="module-item">
                        <div class="module-info">
                          <span class="module-name">{{
                            getModuleNameByCode(mod.module_code)
                            }}</span>
                          <span class="module-code">({{ mod.module_code }})</span>
                        </div>
                        <div class="module-details">
                          Weight: {{ mod.weight }} | Position:
                          {{ mod.position }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="group.createSubGroups" class="group-submodule-section">
                    <div class="group-submodule-title">Submodules</div>
                    <div>No. of subgroups: {{ group.numberOfSubGroups }}</div>
                  </div>

                  <!-- View More Overlay -->
                  <div class="group-summary-overlay" *ngIf="!group.isExpanded">
                    <button class="view-more-button" (click)="toggleGroupExpansion(gIdx)">
                      <span>View Full Configuration</span>
                      <span class="material-icons view-more-icon">keyboard_arrow_down</span>
                    </button>
                  </div>
                </div>

                <!-- Button Container -->
                <div class="group-buttons-container">
                  <button mat-stroked-button color="primary" class="view-configure-button" (click)="onEditGroup(group)">
                    View & Configure
                  </button>

                  <!-- Collapse Button (shown when expanded) -->
                  <button class="collapse-button" *ngIf="group.isExpanded" (click)="toggleGroupExpansion(gIdx)"
                    matTooltip="Collapse" aria-label="Collapse">
                    <span class="material-icons collapse-icon">keyboard_arrow_up</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isThirdStepError" style="color: red; margin-bottom: 8px">
            Please create at least one group before proceeding.
          </div>
        </form>
      </ng-container>
    </mat-step>
    <mat-step [stepControl]="fourthFormGroup" label=" "
      style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
      <p-divider type="solid"></p-divider>
      <!-- Navigation buttons at top -->
      <div class="step-navigation-top"
        style="display: flex; justify-content: space-between; padding: 8px 16px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px;">
        <button mat-button (click)="onSiteScoreStepBack(stepper)">
          <mat-icon style="vertical-align: middle; margin-right: 4px">arrow_back</mat-icon>Back
        </button>
        <button mat-button matStepperNext (click)="onFourthStepNext(stepper)">
          Next
          <mat-icon style="vertical-align: middle; margin-left: 4px">arrow_forward</mat-icon>
        </button>
      </div>
      <form [formGroup]="fourthFormGroup" class="site-score-form" style="
          flex: 1;
          overflow-y: auto;
          padding-right: 8px;
          height: 60vh;
        ">
        <ng-template matStepLabel>
          <span class="step-label-large" [ngClass]="{
              'step-completed': isFourthStepCompleted,
              'step-error': isFourthStepError
            }">
            <span class="material-icons step-label-icon" [ngClass]="{
                'icon-completed': isFourthStepCompleted,
                'icon-error': isFourthStepError
              }">
              {{
              isFourthStepCompleted
              ? "done"
              : isFourthStepError
              ? "error"
              : ""
              }}
            </span>
            {{ isCategoryMode ? 'Category Score' : 'Site Score' }}
          </span>
        </ng-template>
        <div style="
            position: absolute;
            top: 60px;
            right: 32px;
            z-index: 10;
            display: flex;
            align-items: center;
            gap: 8px;
          ">
          <span>Configuration Tutorial</span>
          <img src="assets/images/icons8-info-50.png" alt="Help" style="width: 24px; height: 24px; cursor: pointer"
            (click)="openYoutubeHelp(youtubeStepVideoIds[0])" />
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            margin-top: 32px;
          ">
          <span style="font-weight: 600; font-size: 16px; color: #1976d2">
            {{ isCategoryMode ? 'CATEGORY SCORE' : 'SITE SCORE' }}
          </span>
          <div style="display: flex; align-items: center; gap: 24px">
            <div style="display: flex; align-items: center; gap: 6px">
              <span style="
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  background: #e53935;
                  color: #fff;
                  font-weight: bold;
                  font-size: 12px;
                ">
                L
              </span>
              <span style="color: #e53935; font-weight: 500">Low Range</span>
            </div>
            <div style="display: flex; align-items: center; gap: 6px">
              <span style="
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  background: #fbc02d;
                  color: #fff;
                  font-weight: bold;
                  font-size: 12px;
                ">
                M
              </span>
              <span style="color: #fbc02d; font-weight: 500">Medium Range</span>
            </div>
            <div style="display: flex; align-items: center; gap: 6px">
              <span style="
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  background: #43a047;
                  color: #fff;
                  font-weight: bold;
                  font-size: 12px;
                ">
                H
              </span>
              <span style="color: #43a047; font-weight: 500">High Range</span>
            </div>
          </div>
        </div>
        <div class="site-score-table-container" style="overflow-x: auto; margin-bottom: 20px">
          <table class="module-range-table">
            <thead>
              <tr>
                <th style="
                    min-width: 140px;
                    width: 100px;
                    text-align: left;
                    padding-left: 16px;
                  ">
                  Module/Range
                </th>
                <th *ngFor="let n of [].constructor(11); let i = index"
                  style="width: 32px; text-align: center; margin-left: -10px">
                  {{ i }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let mod of dynamicModuleRanges; let idx = index">
                <td>
                  {{ mod.name }}
                  <span style="color: #888">({{ mod.code }})</span>
                </td>
                <td colspan="11" style="
                    position: relative;
                    padding: 0;
                    margin: 0;
                    border: none;
                    overflow-x: visible;
                  ">
                  <div class="slider-indicator slider-indicator-left" [style.left.%]="getPercent(mod.range[0])">
                    {{ mod.range[0] }}
                  </div>
                  <div class="slider-indicator slider-indicator-right" [style.left.%]="getPercent(mod.range[1])">
                    {{ mod.range[1] }}
                  </div>
                  <div class="custom-slider-container" style="width: 92%; max-width: 350px; min-width: 180px">
                    <div class="slider-bar" [style.background]="
                        getSliderGradient(mod.range[0], mod.range[1])
                      "></div>
                    <input type="range" [min]="sliderMin" [max]="sliderMax" [step]="1" [(ngModel)]="mod.range[0]"
                      [ngModelOptions]="{ standalone: true }" (input)="onLeftChange(idx)"
                      class="slider-handle slider-handle-left" [style.zIndex]="mod.range[0] === mod.range[1] ? 4 : 3" />

                    <input type="range" [min]="sliderMin" [max]="sliderMax" [step]="1" [(ngModel)]="mod.range[1]"
                      [ngModelOptions]="{ standalone: true }" (input)="onRightChange(idx)"
                      class="slider-handle slider-handle-right"
                      [style.zIndex]="mod.range[0] === mod.range[1] ? 4 : 2" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </mat-step>
    <mat-step style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
      <p-divider type="solid"></p-divider>
      <!-- Navigation buttons at top -->
      <div class="step-navigation-top"
        style="display: flex; justify-content: space-between; padding: 8px 16px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px;">
        <button mat-button (click)="onOpenOpexStepBack(stepper)">
          <mat-icon style="vertical-align: middle; margin-right: 4px">arrow_back</mat-icon>Back
        </button>
        <button mat-button matStepperNext>
          Next
          <mat-icon style="vertical-align: middle; margin-left: 4px">arrow_forward</mat-icon>
        </button>
      </div>
      <div style="
          flex: 1;
          overflow-y: auto;
          padding-right: 8px;
          height: 60vh;
        ">
        <ng-template matStepLabel>
          <span class="step-label-large" [ngClass]="{
              'step-completed': isOpexStepCompleted,
              'step-error': isOpexStepError
            }">
            <span class="material-icons step-label-icon" [ngClass]="{
                'icon-completed': isOpexStepCompleted,
                'icon-error': isOpexStepError
              }">
              {{
              isOpexStepCompleted ? "done" : isOpexStepError ? "error" : ""
              }}
            </span>
            Open Opex
          </span>
        </ng-template>
        <div style="
            position: absolute;
            top: 60px;
            right: 32px;
            z-index: 10;
            display: flex;
            align-items: center;
            gap: 8px;
          ">
          <span>Configuration Tutorial</span>
          <img src="assets/images/icons8-info-50.png" alt="Help" style="width: 24px; height: 24px; cursor: pointer"
            (click)="openYoutubeHelp(youtubeStepVideoIds[0])" />
        </div>
        <div style="
            display: flex;
            height: 100%;
            flex: 1;
            overflow: hidden;
            padding-right: 8px;
          ">
          <!-- Sidebar with checkboxes -->
          <div class="opex-sidebar" style="
              min-width: 250px;
              max-width: 300px;
              height: 100%;
              border-right: 1px solid #e0e0e0;
              display: flex;
              flex-direction: column;
            ">
            <h4 style="
                margin: 0 0 16px 0;
                padding: 16px 16px 0 16px;
                flex-shrink: 0;
                background: inherit;
                color: white;
                font-weight: 600;
              ">
              Select Opex Modules
            </h4>
            <div style="
                flex: 1;
                overflow-y: scroll;
                padding: 0 16px 16px 16px;
                background: #06152b;
              ">
              <div *ngFor="let param of opexParameters; let i = index">
                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 6px;
                  ">
                  <mat-checkbox [(ngModel)]="param.checked" [name]="'opexParam' + i" style="
                      margin-right: 0;
                      vertical-align: middle;
                      color: white;
                      flex-shrink: 0;
                    "></mat-checkbox>
                  <span [ngClass]="{
                      'sidebar-param-label': true,
                      'sidebar-param-label--active':
                        selectedOpexIndex === i && param.checked,
                      'sidebar-param-label--disabled': !param.checked
                    }" (click)="onSidebarParamClick(i)" style="
                      cursor: pointer;
                      vertical-align: middle;
                      font-size: 16px;
                      word-wrap: break-word;
                      flex: 1;
                    ">
                    {{ param.label }}
                  </span>
                </div>
                <div *ngIf="i < opexParameters.length - 1" style="
                    height: 1px;
                    background: #e0e0e01f;
                    margin: 0 0 6px 0;
                    width: 100%;
                  "></div>
              </div>
            </div>
          </div>
          <!-- Table area -->
          <div style="
              flex: 1;
              padding: 16px;
              display: flex;
              flex-direction: column;
              max-height: 100%;
            ">
            <div *ngIf="
                selectedOpexIndex !== null &&
                opexParameters[selectedOpexIndex]?.checked
              " style="
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
              ">
              <!-- Fixed Header -->
              <div style="flex-shrink: 0; border-bottom: 2px solid #ddd">
                <table class="opex-table" style="width: 100%; border-collapse: collapse">
                  <thead>
                    <tr>
                      <th style="width: 80px"></th>
                      <!-- Checkbox column -->
                      <th style="width: 120px">Parameters</th>
                      <th style="width: 120px">Details</th>
                      <th style="width: 80px">Units</th>
                      <th style="width: 80px">Type</th>
                      <th style="width: 80px">Code</th>
                      <th style="width: 90px">Upload Type</th>
                      <th style="width: 80px">Formula</th>
                      <th style="width: 80px">Price Type</th>
                      <th style="width: 80px">Price</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <!-- Scrollable Body -->
              <div style="flex: 1; overflow-y: auto">
                <table class="opex-table" style="width: 100%; border-collapse: collapse">
                  <tbody>
                    <tr *ngFor="
                        let row of getOpexDataForSelected();
                        let i = index
                      ">
                      <td style="vertical-align: middle; padding: 0; width: 80px">
                        <div style="
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            height: 64px;
                            min-width: 48px;
                          ">
                          <mat-checkbox [(ngModel)]="row.selected" style="
                              margin-bottom: 2px;
                              width: 32px;
                              height: 32px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            ">
                          </mat-checkbox>
                          <div style="display: flex; gap: 2px">
                            <ng-container *ngIf="editingOpexRow === row; else editIcon">
                              <button mat-icon-button color="primary" (click)="saveOpexRowEdit()" style="
                                  width: 32px;
                                  height: 32px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">
                                <mat-icon style="font-size: 20px">check</mat-icon>
                              </button>
                              <button mat-icon-button color="warn" (click)="cancelOpexRowEdit()" style="
                                  width: 32px;
                                  height: 32px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">
                                <mat-icon style="font-size: 20px">close</mat-icon>
                              </button>
                            </ng-container>
                            <ng-template #editIcon>
                              <button mat-icon-button [disabled]="!row.selected" (click)="startEditOpexRow(row)" style="
                                  width: 32px;
                                  height: 32px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">
                                <mat-icon style="font-size: 20px">edit</mat-icon>
                              </button>
                            </ng-template>
                          </div>
                        </div>
                      </td>
                      <ng-container *ngIf="editingOpexRow === row; else viewRow">
                        <td style="width: 120px">
                          <input 
                            [(ngModel)]="row.parameter_name" 
                            style="width: 120px"
                            [class.invalid]="!row.parameter_name || (row.parameter_name && row.parameter_name.trim() === '')"
                            required />
                        </td>
                        <td style="width: 120px">
                          <input [(ngModel)]="row.details" style="width: 120px" />
                        </td>
                        <td style="width: 80px">
                          <input [(ngModel)]="row.parameter_unit" style="width: 80px" />
                        </td>
                        <td style="width: 80px">
                          <select [(ngModel)]="row.parameter_type" style="width: 76px; font-size: 14px; padding: 2px;">
                            <option value="Raw">RAW</option>
                            <option value="Score">SCORE</option>
                            <option value="Delta">DELTA</option>
                            <option value="Conditional">CONDITIONAL</option>
                          </select>
                        </td>
                        <td style="width: 80px">
                          <input [(ngModel)]="row.parameter_code" style="width: 80px" readonly />
                        </td>
                        <td style="width: 90px">
                          <select [(ngModel)]="row.uploadType" style="width: 90px">
                            <option value="Manual">Manual</option>
                            <option value="Online">Online</option>
                          </select>
                        </td>
                        <td style="width: 80px; max-width: 80px; overflow: hidden;">
                          <div style="display: flex; flex-direction: column; align-items: center; gap: 4px; width: 100%;">
                            <span style="
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 14px;
                                text-align: center;
                                min-width: 0;
                              " [title]="row.formula || ''">{{ row.formula || '' }}</span>
                            <img src="assets/images/icons8-formula-fx-50.png" alt="Edit formula" style="
                                width: 20px;
                                height: 20px;
                                cursor: pointer;
                                flex-shrink: 0;
                              " (click)="openFormulaEditor(row)" />
                          </div>
                        </td>
                        <td style="width: 80px">
                          <select [(ngModel)]="row.price_type" style="width: 80px">
                            <option value="Fixed">Fixed</option>
                            <option value="Dynamic">Dynamic</option>
                          </select>
                        </td>
                        <td style="width: 80px">
                          <input 
                            type="number" 
                            [(ngModel)]="row.price" 
                            style="width: 80px"
                            step="0.01"
                            min="0"
                            (keypress)="onPriceKeyPress($event)" />
                        </td>
                      </ng-container>
                      <ng-template #viewRow>
                        <td style="width: 120px">{{ row.parameter_name }}</td>
                        <td style="width: 120px">{{ row.details }}</td>
                        <td style="width: 80px">{{ row.parameter_unit }}</td>
                        <td style="width: 80px; font-size: 16px;">{{ row.parameter_type }}</td>
                        <td style="width: 80px">{{ row.parameter_code }}</td>
                        <td style="width: 90px">
                          <select [(ngModel)]="row.uploadType" style="width: 90px">
                            <option value="Manual">Manual</option>
                            <option value="Online">Online</option>
                          </select>
                        </td>
                        <td style="width: 80px; max-width: 80px; overflow: hidden;">
                          <div style="display: flex; flex-direction: column; align-items: center; gap: 4px; width: 100%;">
                            <span style="
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 14px;
                                text-align: center;
                                min-width: 0;
                              " [title]="row.formula || ''">{{ row.formula || '' }}</span>
                            <img src="assets/images/icons8-formula-fx-50.png" alt="Edit formula" style="
                                width: 20px;
                                height: 20px;
                                cursor: pointer;
                                flex-shrink: 0;
                              " (click)="openFormulaEditor(row)" />
                          </div>
                        </td>
                        <td style="width: 80px">
                          <select [(ngModel)]="row.price_type" style="width: 80px">
                            <option value="Fixed">Fixed</option>
                            <option value="Dynamic">Dynamic</option>
                          </select>
                        </td>
                        <td style="width: 80px">{{ row.price }}</td>
                      </ng-template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div *ngIf="
                selectedOpexIndex === null ||
                !opexParameters[selectedOpexIndex]?.checked
              " style="color: #888; padding: 24px 0">
              Select a checked parameter to view details.
            </div>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step [stepControl]="fifthFormGroup" label=""
      style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
      <p-divider type="solid"></p-divider>
      <!-- Navigation buttons at top -->
      <div class="step-navigation-top"
        style="display: flex; justify-content: space-between; padding: 8px 16px; background: #f5f5f5; border-radius: 4px; margin-bottom: 8px;">
        <button mat-button color="black" (click)="stepper.previous()" style="background-color: #ffffff;">
          <mat-icon style="vertical-align: middle; margin-right: 4px">arrow_back</mat-icon>Back
        </button>
        <button mat-raised-button color="primary" (click)="onSave()" style="background-color: #1976d2;">
          Save
          <mat-icon style="vertical-align: middle; margin-left: 4px">save</mat-icon>
        </button>
      </div>
      <form [formGroup]="fifthFormGroup" style="flex: 1; overflow-y: auto; padding-right: 8px; margin-bottom: 0">
        <ng-template matStepLabel>
          <span class="step-label-large" [ngClass]="{
              'step-completed': isAiTopicStepCompleted,
              'step-error': isAiTopicStepError
            }">
            <span class="material-icons step-label-icon" [ngClass]="{
                'icon-completed': isAiTopicStepCompleted,
                'icon-error': isAiTopicStepError
              }">
              {{
              isAiTopicStepCompleted
              ? "done"
              : isAiTopicStepError
              ? "error"
              : ""
              }}
            </span>
            AI Topic Settings
          </span>
        </ng-template>
        <div style="
            position: absolute;
            top: 60px;
            right: 32px;
            z-index: 10;
            display: flex;
            align-items: center;
            gap: 8px;
          ">
          <span>Configuration Tutorial</span>
          <img src="assets/images/icons8-info-50.png" alt="Help" style="width: 24px; height: 24px; cursor: pointer"
            (click)="openYoutubeHelp(youtubeStepVideoIds[4])" />
        </div>

        <!-- AI Topic Settings Content -->
        <div class="config-row" style="padding: 0; background: #fff; border-radius: 8px; min-height: 500px;">
          <!-- Header Section -->
          <!-- <div style="padding: 20px 20px 0 20px; border-bottom: 1px solid #e0e0e0; margin-bottom: 20px;">
            <h3 style="color: #1976d2; margin: 0 0 8px 0; font-size: 24px; font-weight: 600;">
              Configure AI Topics and Subtopics
            </h3>
            <p style="color: #666; margin: 0; font-size: 14px;">
              Set up AI topics and their corresponding subtopics for intelligent data analysis and insights.
            </p>
          </div> -->

          <!-- Custom wrapper for the AI Topic component to override styles -->
          <div class="ai-topic-stepper-wrapper w-100" style="padding: 0 20px 20px 20px;">
            <app-local-topic-manager [triggerSave]="shouldSaveTopics"></app-local-topic-manager>
          </div>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</div>
<div *ngIf="formulaEditorVisible" class="custom-editor-modal">
  <div class="custom-editor-backdrop" (click)="formulaEditorVisible = false"></div>
  <div class="custom-editor-content">
    <h3>Edit Formula</h3>
    <textarea [(ngModel)]="formulaEditorText" style="
        width: 100%;
        height: 120px;
        font-size: 15px;
        padding: 10px;
        border-radius: 6px;
        border: 1px solid #ccc;
      " placeholder="Enter formula here..."></textarea>
    <div style="text-align: right; margin-top: 16px">
      <button mat-stroked-button color="primary" (click)="formulaEditorVisible = false" style="margin-right: 12px">
        Cancel
      </button>
      <button mat-flat-button color="accent" (click)="saveFormulaEditor()">
        Save
      </button>
    </div>
  </div>
</div>
<div *ngIf="youtubeHelpVisible" class="custom-editor-modal">
  <div class="custom-editor-backdrop" (click)="closeYoutubeHelp()"></div>
  <div class="custom-editor-content" style="max-width: 1040px; width: 90vw; height: 80vh; position: relative">
    <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 2;
        padding: 0 16px;
        background: #06152b;
        border-radius: 8px 8px 0 0;
        height: 56px;
      ">
      <img class="logo" src="./assets/images/logo_new.png" style="height: 40px" />
      <button mat-icon-button (click)="closeYoutubeHelp()" style="color: whitesmoke">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <iframe [src]="youtubeEmbedUrl" width="560" height="615" frameborder="0" allowfullscreen style="
        border-radius: 8px;
        width: 100%;
        height: 90%;
        margin-top: 56px;
      "></iframe>
  </div>
</div>

<!-- Site Description Expanded Modal -->
<div *ngIf="isDescriptionModalOpen" class="description-modal-overlay">
  <div class="description-modal-backdrop" (click)="closeDescriptionModal()"></div>
  <div class="description-modal-content">
    <div class="description-modal-header">
      <h3 style="margin: 0; color: #1976d2; font-weight: 600;">
        {{ isCategoryMode ? 'Category Description' : 'Site Description' }}
      </h3>
      <button type="button" class="description-modal-close" (click)="closeDescriptionModal()">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="description-modal-body">
      <textarea [(ngModel)]="descriptionModalText" [ngModelOptions]="{standalone: true}"
        class="description-modal-textarea"
        [placeholder]="isCategoryMode ? 'Enter category description' : 'Enter site description'"></textarea>
    </div>
    <div class="description-modal-footer">
      <button type="button" class="description-modal-cancel-btn" (click)="closeDescriptionModal()">
        Cancel
      </button>
      <button type="button" class="description-modal-save-btn" (click)="saveDescriptionModal()">
        <span class="material-icons" style="font-size: 18px; margin-right: 4px;">save</span>
        Save
      </button>
    </div>
  </div>
</div>